import React from "react";
import "./Terms_TN.css";

const Terms_TN = () => {
  return (
    <div className="privacy-policy-page">
      {/* <h1 align="center" className="heading-title">Mahakumbh Mela Festive</h1> */}
      <h3 align="center" className="page-title">
        Terms of Use
      </h3>
      <p>
        EFFECTIVE DATE: 1st August 2026
      </p>
      <p>
        Coca-Cola Halftime Surprise 2026
      </p>
      <ol className="terms-list">
        <li>
          You Agree to These Terms by Using this Platform. Your access to, and
          use of, the platform available at{" "}
          <a
            href="https://www.coke2home.com/halftime-surprise/tn/tnc"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.coke2home.com/halftime-surprise/tn/tnc
          </a>{" "}
          (‘Platform') is subject to the following Terms of Use and all
          applicable laws and regulations.
        </li>
        <li>
          The Platform is powered by Google Gemini’s artificial intelligence
          technology and has been developed exclusively for Coca-Cola India
          Private Limited (“CCIPL”) by Google LLC (“Google”). The Platform
          enables users to generate AI-powered images (‘AI-Generated Content’)
          using Google Gemini’s features.
        </li>
        <li>
          By accessing and using the Platform, you accept, without limitation or
          qualification, these Terms of Use, and acknowledge that any other
          agreements between you and CCIPL which shall include its direct or
          indirect subsidiaries and affiliated entities, (collectively referred
          hereon forward as ‘CCIPL’) are superseded with respect to this subject
          matter. If you do not agree and accept, without limitation or
          qualification, these Terms of Use, please exit the Platform.
        </li>
        <li>
          Ownership of Content. The Platform and all of its contents including,
          but not limited to, all text, logos, videos, images, AI-Generated
          Content, and underlying AI models and algorithms (‘Content’) are owned
          and copyrighted by Google with all rights reserved unless otherwise
          noted. The AI-Generated Content created through the Platform is
          generated using Google Gemini technology licensed exclusively to
          CCIPL. This Platform features logos, brand identities and other
          trademarks and service marks (collectively, the ‘Marks’) that are the
          registered and/or unregistered trademark of the Coca-Cola Company
          (“TCCC”), Google and/or their respective subsidiaries. Nothing
          contained on this Platform should be construed as granting, by
          implication, estoppel, or otherwise, any license or right to use any
          Mark displayed on this Platform without written permission of CCIPL,
          Google or any such third party that may own a Mark displayed on the
          Platform. Your use of any Content, except as provided in these Terms
          of Use, without the written permission of the Content owner is
          strictly prohibited. You are also advised that CCIPL and Google will
          aggressively enforce their intellectual property rights to the fullest
          extent of the law, including the seeking of criminal prosecution
        </li>
        <li>
          Use of the Platform and Age Limit. The Platform is intended for
          audiences of the age 18 and above only.
        </li>
        <li>
          Your Use of the Platform. CCIPL grants you permission to use the
          Platform as follows:
          <div>
            <ol type="a" start="1">
              <li>
                <p>
                  you may download AI-Generated Content and other Content, but
                  only for non-commercial, personal use and provided that you
                  also retain all copyright and other proprietary notices
                  contained on the Content;
                </p>
              </li>
              <li>
                <p>
                  you may not distribute, modify, copy (except as set forth
                  above), transmit, display, reuse, reproduce, publish, license,
                  create derivative works from, transfer, sell or otherwise use
                  Content or AI-Generated Content without CCIPL’s written
                  permission;
                </p>
              </li>
              <li>
                <p>
                  you are prohibited from using the Platform to generate, post
                  or transmit any infringing, threatening, false, misleading,
                  abusive, harassing, libelous, defamatory, vulgar, obscene,
                  scandalous, inflammatory, pornographic, or profane material,
                  or any material depicting real individuals without their
                  consent, or any material that could constitute or encourage
                  conduct that would be considered a criminal offense, give rise
                  to civil liability, or otherwise violate any law. You may
                  further not use the Platform for any purpose that is unlawful
                  or prohibited by these Terms of Use or any applicable laws.
                  CCIPL will fully cooperate with any law enforcement
                  authorities or any court order requesting or directing CCIPL
                  to disclose the identity of anyone generating, posting or
                  transmitting any such information or materials, or any other
                  information or materials;
                </p>
              </li>
              <li>
                <p>
                  you are prohibited from using the Platform to advertise or
                  perform any commercial solicitation. CCIPL may periodically
                  revise the Content and reserves the right to make such changes
                  without any obligation to notify you;
                </p>
              </li>
              <li>
                <p>
                  you are expressly prohibited from incorporating any of the
                  material from this Platform, including any AI-Generated
                  Content, in any other work, publication, or website of your
                  own or belonging to another. You must not use any AI-Generated
                  Content, images, information or content on our Platform for
                  commercial purposes without obtaining a license to do so from
                  CCIPL or its licensors. Any unauthorised use of the
                  AI-Generated Content, images, information and content may
                  violate copyright laws, other intellectual property laws,
                  applicable privacy laws as well as communications regulations
                  and statutes. CCIPL does not give any commitment that your use
                  of materials displayed on or generated through the Platform
                  will not infringe rights of third parties.
                </p>
              </li>
            </ol>
          </div>
        </li>
        <li>
          <p>
            Unauthorised use of the Platform or any content on the Platform
            (including without limitation any software, AI models, or
            AI-Generated Content made available through the Platform) may in
            certain jurisdictions result in monetary damages and other civil and
            criminal penalties including, without limitation, for copyright
            infringement. You may only use our Platform for lawful purposes. You
            must not:
          </p>
          <ol type="a" start="1">
            <li>
              <p>
                introduce viruses, trojans, worms, logic bombs, spyware or other
                computer code, file or program that is harmful or invasive or is
                intended to damage or hijack the operation of, or monitor the
                use of, any hardware, software or equipment.
              </p>
            </li>
            <li>
              <p>
                attempt to gain unauthorised access to our Platform, the server
                on which our Platform is hosted, or any server, computer, AI
                model, or database connected to our Platform.
              </p>
            </li>
            <li>
              <p>
                restrict or inhibit any person from using our Platform
                (including by hacking or defacing any portion of our Platform).
              </p>
            </li>
            <li>
              <p>
                modify, adapt, translate, reverse engineer, decompile or
                disassemble any portion of our Platform, including the
                underlying AI models or algorithms.
              </p>
            </li>
            <li>
              <p>
                remove any copyright, trademark or other proprietary rights
                notice from our Platform or from materials originating from our
                Platform.
              </p>
            </li>
            <li>
              <p>
                frame or mirror any part of our Platform without our express
                prior written consent.
              </p>
            </li>
            <li>
              <p>
                {" "}
                create a database by systematically downloading and storing all
                or any content accessible on our Platform, including
                AI-Generated Content.
              </p>
            </li>
            <li>
              <p>
                {" "}
                use any robot, spider, website search/retrieval application or
                other manual or automatic device to retrieve, index, ‘scrape’,
                ‘data mine’ or in any way reproduce or circumvent the
                navigational structure or presentation of our Platform, without
                our express prior written consent.
              </p>
            </li>
            <li>
              <p>
                publish any unsolicited or unauthorised advertising, promotional
                materials, ‘junk mail’, ‘spam’, ‘chain letters’, ‘pyramid
                scheme’ or investment opportunity, or any other form of
                solicitation.
              </p>
            </li>
            <li>
              <p>
                publish any material non-public information about a person or a
                company without the proper authorisation to do so.
              </p>
            </li>
            <li>
              <p>
                use our Platform for any illegal or unlawful purpose or
                activity.
              </p>
            </li>
            <li>
              <p>
                attempt to manipulate, exploit, or circumvent the AI model’s
                safety filters, content policies, or usage restrictions,
                including through prompt injection, adversarial inputs, or any
                technique designed to produce outputs that violate these Terms
                of Use.
              </p>
            </li>
            <li>
              <p>
                use the Platform to generate AI-Generated Content that
                impersonates real individuals, creates deepfakes, or produces
                misleading or deceptive imagery.
              </p>
            </li>
            <li>
              <p>
                use the Platform to generate AI-Generated Content for the
                purpose of spreading misinformation, disinformation, or
                propaganda.
              </p>
            </li>
            <li>
              <p>
                use the AI-Generated Content to train, fine-tune, or develop any
                competing AI model or service without express prior written
                consent from CCIPL and Google.
              </p>
            </li>
          </ol>
        </li>
        <li>
          User-Generated Content and AI-Generated Content. We include features
          on our Platform that allow you to create AI-Generated Content using
          Google Gemini’s features and to share your content with us and other
          users of our Platform. By generating AI-Generated Content through the
          Platform, you acknowledge that such content is produced by artificial
          intelligence and may not be unique, as similar or identical outputs
          may be generated for other users using similar inputs. You further
          acknowledge that AI-Generated Content may contain inaccuracies,
          artefacts, or unintended outputs. By sharing content through the
          Platform, your content may become publicly accessible. To the extent
          permitted by law, you hereby grant CCIPL and its affiliated entities a
          worldwide, non-exclusive, transferable, royalty-free, perpetual,
          irrevocable right and licence, without compensation to you:
          <div>
            <ol type="a" start="1">
              <li>
                <p>
                  to use, reproduce, distribute, adapt (including without
                  limitation edit, modify, translate and reformat), derive,
                  transmit, display and perform (publicly or otherwise) such
                  content, including any AI-Generated Content and the inputs or
                  prompts used to generate such content, in any media now known
                  or hereafter developed, for CCIPL and/or affiliated entities’
                  business purposes; and
                </p>
              </li>
              <li>
                <p>
                  to sublicense the foregoing rights, through multiple tiers, to
                  the maximum extent permitted by applicable law; and
                </p>
              </li>
              <li>
                <p>
                  to use any inputs, prompts, or instructions you provide to the
                  Platform for the purpose of improving, training, or enhancing
                  the AI models and services, subject to Section 12 (Privacy)
                  and applicable data protection laws.
                </p>
              </li>
            </ol>
          </div>
        </li>
        <li>
          The foregoing licences shall survive any termination of your use of
          our Platform. For all the content you share through our Platform,
          including AI-Generated Content, you represent and warrant that you
          have all necessary rights for you to grant these licenses, and that
          such content complies with all applicable laws, rules and regulations
          and does not infringe or otherwise violate the copyright, trademark,
          trade secret, privacy or other intellectual property or other rights
          of any third party and is furthermore free from viruses and other
          malware. You further, to the extent permissible by law, irrevocably
          waive any ‘moral rights’ or other rights with respect to attribution
          of authorship or integrity of materials regarding each item of user
          content or AI-Generated Content that you submit or create through the
          Platform. You acknowledge and agree that any AI-Generated Content is
          produced by automated means and CCIPL makes no representation that you
          will have exclusive rights to any AI-Generated Content. We do not
          solicit or encourage submissions of content containing ideas or
          suggestions relating to our Platform, our business or our affiliated
          entities’ businesses.
        </li>
        <li>
          AI-Generated Content Disclaimer. You acknowledge and agree that: (a)
          AI-Generated Content is created using Google Gemini technology and is
          provided ‘as is’ without any guarantee of accuracy, completeness,
          originality, or fitness for any particular purpose; (b) AI-Generated
          Content may include unintended biases, inaccuracies, or artefacts
          inherent in AI technology; (c) CCIPL and Google do not warrant that
          any AI-Generated Content will be free from errors, defects, or
          intellectual property claims by third parties; (d) you are solely
          responsible for reviewing and verifying any AI-Generated Content
          before use; and (e) CCIPL and Google shall not be liable for any loss,
          damage, or claim arising from your use of or reliance on any
          AI-Generated Content.
        </li>
        <li>
          Google Gemini Technology. The Platform utilizes Google Gemini’s AI
          technology, which has been developed and made available exclusively
          for CCIPL. By using the Platform, you acknowledge that: (a) the AI
          features are powered by Google LLC and are subject to Google’s
          applicable usage policies; (b) your use of AI features may be subject
          to additional terms and conditions imposed by Google; (c) Google may
          collect and process certain data in connection with the provision of
          its AI services, in accordance with Google’s privacy policy and
          applicable data protection laws; and (d) CCIPL makes no warranties
          regarding the availability, performance, or continuity of Google
          Gemini’s services, and any interruption, modification, or
          discontinuation of such services shall not give rise to any liability
          on the part of CCIPL.
        </li>
        <li>
          Privacy. Any personal data (for example, your name, address, telephone
          number or e-mail address) you transmit to the Platform by electronic
          mail or otherwise may be used by CCIPL in accordance with the
          Platform’s Privacy Policy available at {" "}
          <a
            href="https://datatrust.coca-cola.com/xg/en#global-privacy-notices"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://datatrust.coca-cola.com/xg/en#global-privacy-notices
          </a>
          . Any inputs, prompts, or content you provide to the AI features of
          the Platform may be processed by Google in accordance with Google’s
          privacy policy. Any other communication or material you transmit to
          the Platform, such as questions, comments, suggestions or the like,
          will be treated as non-confidential and non-proprietary.
        </li>
        <li>
          Disclaimer of Warranties. All Content, including AI-Generated Content,
          is subject to change and is provided to you ‘as is’ without any
          warranty of any kind, either expressed or implied, including, but not
          limited to, the implied warranties of merchantability, fitness for a
          particular purpose, or non-infringement. CCIPL and Google neither
          warrant nor represent that your use of any Content or AI-Generated
          Content will not infringe the rights of any third parties nor that the
          Content will be accurate, complete, or up to date. We use all
          reasonable efforts to include accurate and up to date information on
          the Platform. However, CCIPL makes no warranties or representations as
          to the accuracy, correctness or reliability of the information or
          AI-Generated Content provided through the Platform. Accordingly, CCIPL
          and Google assume no liability or responsibility for any omissions or
          errors (including, without limitation, typographical errors, technical
          errors, and errors or inaccuracies in AI-Generated Content) in the
          Content of the Platform. Information and AI-Generated Content on the
          Platform are subject to change without notice.
        </li>
        <li>
          Exclusion of Liability. Your use of the Platform is at your own risk.
          Neither CCIPL, Google, nor any of their respective subsidiaries,
          affiliates, officers or directors, nor any of their agents or any
          other party involved in creating, producing, or delivering the
          Platform, including the AI features, are liable for any direct,
          indirect, punitive, incidental, special, consequential or other
          damages arising out of or in any way connected with the use of this
          Platform, Content, or AI-Generated Content whether based on contract,
          tort, strict liability or otherwise, for, without limitation damages
          for lost profits, loss of goodwill, loss of data, work stoppage,
          accuracy of results, computer failure or malfunction, even if advised
          of the possibility of any such damages. Without limiting the
          foregoing, CCIPL and Google shall not be liable for any claims,
          losses, or damages arising from: (a) the accuracy, quality, or nature
          of any AI-Generated Content; (b) any reliance placed on AI-Generated
          Content; (c) the use of AI-Generated Content by you or any third
          party; or (d) any intellectual property infringement claims related to
          AI-Generated Content.
        </li>
        <li>
          Indemnification. You agree to defend, indemnify and hold CCIPL and
          Google harmless from and against any and all claims, damages, costs
          and expenses, including advocate's fees, arising from and related to
          your use of the Platform, including any AI-Generated Content created
          by you or through your Account.
        </li>
        <li>
          Links to Third Party Sites. The Platform may contain links to sites
          owned or operated by parties other than CCIPL, including Google. Such
          links are provided for your convenience only. CCIPL does not control,
          and is not responsible for, the content or privacy policies on, or the
          security of, such sites. Without limiting the foregoing, CCIPL
          specifically disclaims any responsibility if such sites:
          <div>
            <ol type="a" start="1">
              <li>
                <p>infringe any third party's intellectual property rights;</p>
              </li>
              <li>
                <p>are inaccurate, incomplete or misleading;</p>
              </li>
              <li>
                <p>are not merchantable or fit for a particular purpose;</p>
              </li>
              <li>
                <p>do not provide adequate security;</p>
              </li>
              <li>
                <p>
                  contain viruses or other items of a destructive nature; or
                </p>
              </li>
              <li>
                <p>are libelous or defamatory.</p>
              </li>
            </ol>
          </div>
          <p>
            Neither does CCIPL endorse the content, or any products or services
            available, on such sites. If you establish a link to such sites or
            the Platform, you do so at your own risk and without the permission
            of CCIPL.
          </p>
        </li>
        <li>
          {" "}
          Revisions and Suspension of Terms. CCIPL may at any time, and without
          notice, revise these Terms of Use by updating this posting. You are
          bound by any such revisions and should therefore periodically visit
          this page to review the current Terms of Use. We do not guarantee that
          our Platform, or any content on it, including AI features, will always
          be accessible or be uninterrupted. We may suspend or withdraw or
          restrict the availability of all or any part of our Platform,
          including AI features, for business and operational reasons, including
          but not limited to changes in Google Gemini’s services or policies. We
          will endeavor to give you reasonable notice of any suspension or
          withdrawal. We accept no liability or responsibility for any access
          issues you may experience.
        </li>
        <li>
          Law and Jurisdiction. These Terms of Use and your use of the Platform
          are governed by the laws of India, without regard to its choice of law
          provisions. The courts of competent jurisdiction located in Gurgaon
          will have exclusive jurisdiction over any and all disputes arising out
          of, relating to or concerning these Terms of Use and/or the Platform
          or in which these Terms of Use and/or the Platform are a material
          fact.
        </li>
        <li>
          Account Registration. To use certain portions of the Platform,
          including the AI image generation features, you may be required to
          create an account (‘Account’) and create a password. To create an
          Account, you must have a unique, valid email address or mobile number,
          as may be applicable. Accounts cannot be shared. Your username and
          password are for your personal use only and should be kept
          confidential. Each individual can have only one (1) Account. If you
          attempt to exceed this limit in any way, we reserve the right, in our
          sole discretion, to lock, disable, block or delete your Account(s).
          You are responsible for all activities that occur under your Account,
          including any AI-Generated Content created through your Account.
        </li>
        <li>
          Promotions. Any sweepstakes, contests, challenges, activities,
          surveys, or similar promotions made available through the Platform may
          be governed by specific rules that are separate from these Terms. By
          participating in any such sweepstakes, contest, challenge, activity,
          survey, or promotion, you will become subject to those rules, which
          may vary from the terms and conditions set forth herein. We urge you
          to read the applicable rules, which are linked from the particular
          activity, and to review our Privacy Policy which, in addition to these
          Terms, governs any information you submit in connection with such
          activities. If you engage in any fraudulent or unsportsmanlike
          activity or act contrary to the applicable rules, these Terms or any
          laws, your participation and Account privileges may be suspended or
          terminated, resulting in the loss of offers, prizes or other items.
        </li>
        <li>
          Information or Complaints. If you have a question or complaint
          regarding the Platform, please send an e-mail to
          indiahelpline@coca-cola.com. You may also contact us by calling us at
          1800-208-2653.
        </li>
      </ol>
    </div>
  );
};

export default Terms_TN;
